export default [
    {
        path: '/result/403',
        name: '无权限',
        icon: 'none',
        component: () => import('@/pages/result/noPermission')
    }
]


// WEBPACK FOOTER //
// ./src/router/result.js